<template>
  <div>
    <Header />
    <div style="margin-bottom: 15px;">
      <Contents />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../../../components/private/Header";
import Footer from "../../../components/layout/Footer.vue";
import Contents from "./components/Contents.vue"
export default {
  components: {
    Header,
    Contents,
    Footer
  },
};
</script>
